const MAX_NUMBER_OF_RECENT_SEARCHES = 3;

export {
  MAX_NUMBER_OF_RECENT_SEARCHES,
};
